<div class="email-rounded" [ngClass]="{ 'valid-mail': isValid }">
    <input #input type="email" [placeholder]="placeholder" [pattern]="validationPattern" [formControl]="formControl" />
    <div class="valid-tick animated bounceIn" [hidden]="!isValid">
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 0C3.58203 0 0 3.58167 0 8C0 12.4183 3.58203 16 8 16C12.418 16 16 12.4183 16 8C16 3.58167 12.418 0 8 0ZM8 14.5454C4.38525 14.5454 1.45459 11.6149 1.45459 8C1.45459 4.38513 4.38525 1.45453 8 1.45453C11.6147 1.45453 14.5454 4.38513 14.5454 8C14.5454 11.6149 11.6147 14.5454 8 14.5454ZM7.36084 8.60217L9.93213 6.03088C10.2163 5.74707 10.6768 5.74707 10.9609 6.03052C11.2451 6.3147 11.2446 6.77502 10.9604 7.05908L7.875 10.1445C7.59131 10.4286 7.13037 10.4286 6.84619 10.1445L5.30371 8.60254C5.02002 8.31836 5.02002 7.85779 5.30371 7.57385C5.58789 7.28979 6.04834 7.28979 6.33252 7.57385L7.36084 8.60217Z"
                fill="#50BBA0"
            />
        </svg>
    </div>
</div>
